import { menuListItems } from 'assets/menu/menuList';
import { BreadCrumb } from 'components/BreadCrumb';
import { GoToBack } from 'components/GoToBack';
import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import React from 'react';
import { EventForm } from '../EventForm';

import { HeaderContainer } from './styles';
import { useEventNew } from './useEventNew';

export const EventNew: React.FC = () => { 
  const {
    handleInputChange,
    handleSelectChange,
    inputsValues,
    touched,
    errors,
    changeFooter,
    submitButton,
    handleSubmit,
    hasError,
    isLoading,
    customHandleImageChange,
    customHandlePdfChange
  } = useEventNew();

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb itens={["Eventos", "Novo"]} itemActive="Novo" />
          </div>
        </HeaderContainer>
      </Header>

      <EventForm
        handleChange={handleInputChange}
        inputsValues={inputsValues}
        touched={touched}
        errors={errors}
        handleSelectChange={handleSelectChange}
        changeFooter={changeFooter}
        handleSubmit={handleSubmit}
        submitButton={submitButton}
        hasError={hasError}
        isLoading={isLoading}
        customHandleImageChange={customHandleImageChange}
        customHandlePdfChange={customHandlePdfChange}
      />
      
    </Menu>
  );
} 